import { render, staticRenderFns } from "./CancelacionForm.vue?vue&type=template&id=1964cd56&"
import script from "./CancelacionForm.vue?vue&type=script&lang=js&"
export * from "./CancelacionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports